export default __webpack_public_path__ + "static/media/DOLL_P2.bf53d1ae.svg";